import { startTransition, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utility/tracker";
import { useAppSelector } from "../../store";

export function PageTracker() {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.userSlice);

  useEffect(() => {

    const startTime = Date.now();
    const pageName = location.pathname + location.search
    const userId = user?.id;

    setTimeout(() => trackPageView(pageName, userId), 50);

    const sendExitEvent = () => {
      const duration = Math.round((Date.now() - startTime) / 1000); // in seconds      
      trackPageView(pageName, userId, duration);
    };

    window.addEventListener("beforeunload", sendExitEvent);

    return () => {
      sendExitEvent();
      window.removeEventListener("beforeunload", sendExitEvent);
    };
  }, [location.pathname, location.search]);
  return (
    null
  )
}